import styled from "styled-components/macro";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import {
    Grid,
    Divider as MuiDivider,
    Typography,
    Box,
    Theme,
} from "@material-ui/core";
import { spacing } from "@material-ui/system";
import { GettingStartedCard } from "./cards/getting-started-card";
import { CompanyCard } from "./cards/company-card";
import { makeStyles } from "@material-ui/styles";
import { useSelector } from "../../../redux/store";
import i18n from "../../../translations/i18n";

const Divider = styled(MuiDivider)(spacing);
const useStyles = makeStyles((theme: Theme) => ({
    box: {
        height: "100%",
        [theme.breakpoints.down('sm')]: {
            padding: "28px",
        },
    },
    DayDate: {
        backgroundColor: "#2E3B4E",
        boxShadow: "0px 0px 16.9299px rgba(53, 64, 82, 0.05)",
        borderRadius: "4.83711px",
        [theme.breakpoints.down("sm")]: {
            display: "none"
        },
    }
}))

const DayWrapper = styled.div`
    background-color: #2E3B4E;
    box-shadow: 0px 0px 16.9299px rgba(53, 64, 82, 0.05);
    border-radius: 4.83711px;
`;
const DayText = styled.div`
    padding: 4.83711px 9.67421px;
    background: linear-gradient(90deg, #84FAB0 0%, #8FEAFE 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;
function DashboardPage() {
    const classes = useStyles();
    const standard = useSelector(state => state.a11yStandardReducer);
    const { t } = useTranslation();
    console.log({ standard });
    return (
        <Box p={12} className={`${classes.box}`} overflow="scroll">
            {/* disable-scrolls */}
            <Helmet title={t("routes_Dashboard")} />
            <div style={{
                display: "flex",
                flexDirection: "column"
            }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Typography variant="h3" gutterBottom display="inline">
                        {t("dashboard_welcome_message")}
                    </Typography>
                    <div style={{ flexGrow: 1 }}></div>
                    <div className={`${classes.DayDate}`}>
                        <DayText>
                            {new Date().toLocaleDateString(
                                i18n.language,
                                {
                                    month: 'long',
                                    weekday: "long",
                                    day: "2-digit"
                                }
                            ).toLocaleUpperCase()}
                        </DayText>
                    </div>
                </div>
                <Typography variant="subtitle1" gutterBottom display="inline">
                    {t("dashboard_label")}
                </Typography>
            </div>

            <Divider my={4} />

            <Grid container spacing={6}>
                <Grid item sm={8} xs={12}>
                    <GettingStartedCard />
                    {/* <QuestionnaireCompletionCard /> */}
                    <Box mt='15%'></Box>
                </Grid>
                <Grid item sm={4} xs={12}>
                    <CompanyCard />
                </Grid>
            </Grid>
        </Box>
    );
}

export default DashboardPage;
